import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { ErrorHandler } from '@angular/core';

import {
  BASE_UI_TOKEN,
  CONTROL_TYPE,
  FORM_ARRAY_TOKEN,
} from '@d-components/form/form.interface';

import { httpInterceptorProviders } from 'app/core/http-interceptors';
import { InternalErrorHandler } from 'app/core/http-interceptors/internal-error-handler';

import {
  AuthService,
  CheckIdleService,
  CommonService,
  CoreCurrencyService,
  EmployeeService,
  HttpService,
  RoleService,
  SSOService,
  ToastService,
} from '@d-services';

// external libs
import { BaseFormArrayComponent } from '@d-components';
import { FormArrayItemComponent } from '@d-components/form/form-array-item.component';
import { CoreHttpService } from '@d-services/core/core-http.service';
import { MessageService as PrimeNGMessage } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { allBaseUIForm } from './inject-value';
import { LevelGuard } from '@d-guards/level.guard';
import { MerchantCoreService } from '@d-services/core/merchant-core.service';

export const providers = [
  //#region  Service
  AuthService,
  LevelGuard,
  SSOService,
  RoleService,
  HttpService,
  ToastService,
  EmployeeService,
  CommonService,
  CoreHttpService,
  CoreCurrencyService,
  CheckIdleService,
  MerchantCoreService,
  //#endregion

  httpInterceptorProviders,
  {
    provide: BASE_UI_TOKEN,
    useValue: allBaseUIForm,
  },
  {
    provide: FORM_ARRAY_TOKEN,
    useValue: {
      [CONTROL_TYPE.FormArray]: BaseFormArrayComponent,
      arrayItem: FormArrayItemComponent,
    },
  },
  { provide: ErrorHandler, useClass: InternalErrorHandler },
  { provide: LocationStrategy, useClass: PathLocationStrategy },

  //#region  ExternalLibs
  DialogService,
  PrimeNGMessage,
  //#endregion
];
